import React from 'react';
import { motion } from 'framer-motion';
import { Gift } from 'lucide-react';
import { CountdownTimer } from './CountdownTimer';
const bonuses = [{
  id: '01',
  title: 'El Aula en Acción — 20 Talleres de Análisis de Medios',
  value: '15',
  desc: 'Veinte talleres completos, listos para implementar. Cada uno con objetivo, materiales, desarrollo paso a paso y preguntas de cierre. Desde "El Detective del Framing" hasta "Deepfake o Real". Nunca más llegués a clase sin una actividad que funcione.',
  benefit: 'Materiales ya pensados para el aula: ahorrá horas en cada trimestre.'
}, {
  id: '02',
  title: 'El Aula en Acción — Banco de Evaluaciones y Rúbricas',
  value: '15',
  desc: 'Evaluaciones diagnósticas, formativas y sumativas listas para los 4 tomos. Rúbricas de comunicación oral, análisis mediático, producción digital y trabajo en equipo. Banco de 80 preguntas de opción múltiple y 40 de Verdadero y Falso.',
  benefit: 'Nunca más construyas un examen desde cero bajo presión.'
}, {
  id: '03',
  title: 'Creatividad y Ética — Guía de Producción de Contenidos',
  value: '12',
  desc: 'La guía completa para que tus alumnos produzcan podcasts, videos, campañas en redes sociales y periódicos digitales escolares con calidad profesional usando herramientas gratuitas. Con plantillas de guión, checklist de producción y tabla completa de herramientas gratuitas por tipo de proyecto.',
  benefit: 'Nunca más perdás horas buscando cómo armar un proyecto de producción desde cero.'
}, {
  id: '04',
  title: 'Creatividad y Ética — Manual de Ética y Ciberciudadanía',
  value: '12',
  desc: 'El marco ético completo para el mundo digital. Derechos digitales en Latinoamérica, responsabilidades del productor de contenido, 10 dilemas éticos reales para trabajar en el aula, casos latinoamericanos documentados y el Código de Ética Digital para construir con tus alumnos.',
  benefit: 'Lo que ningún manual de comunicación te da y tus alumnos más necesitan hoy.'
}];
export function BonusSection() {
  return <section className="py-24 px-4 bg-dark-card border-y border-dark-border" data-id="element-15">
      <div className="max-w-5xl mx-auto" data-id="element-16">
        <div className="text-center mb-16" data-id="element-17">
          <p className="text-gold font-bold tracking-widest uppercase mb-2" data-id="element-18">
            Incluidos sin costo extra
          </p>
          <h2 className="text-4xl md:text-5xl font-serif font-bold" data-id="element-19">
            🎁 Los 4 Bonos Estratégicos
          </h2>
        </div>

        <div className="grid md:grid-cols-2 gap-6 mb-12" data-id="element-20">
          {bonuses.map((bonus, index) => <motion.div key={index} initial={{
          opacity: 0,
          y: 20
        }} whileInView={{
          opacity: 1,
          y: 0
        }} viewport={{
          once: true
        }} transition={{
          delay: index * 0.1
        }} className="bg-black border border-gold/20 rounded-2xl p-8 relative group hover:border-gold/50 transition-colors" data-id="element-21">
              <div className="absolute top-0 right-0 bg-gold/10 text-gold px-4 py-2 rounded-bl-2xl rounded-tr-2xl font-bold text-sm border-b border-l border-gold/20" data-id="element-22">
                BONO {bonus.id}
              </div>

              <div className="w-12 h-12 bg-gold/20 rounded-full flex items-center justify-center text-gold mb-6" data-id="element-23">
                <Gift size={24} data-id="element-24" />
              </div>

              <h3 className="text-xl font-serif font-bold mb-2 pr-16" data-id="element-25">
                {bonus.title}
              </h3>

              <div className="inline-block bg-white/5 px-3 py-1 rounded mb-4" data-id="element-26">
                <span className="text-gray-400 text-sm" data-id="element-27">
                  Valor real:{' '}
                  <span className="line-through" data-id="element-28">USD {bonus.value}</span>
                </span>
                <span className="text-gold font-bold ml-2" data-id="element-29">→ GRATIS</span>
              </div>

              <p className="text-gray-300 text-sm mb-6 leading-relaxed" data-id="element-30">
                {bonus.desc}
              </p>

              <p className="text-gold-light text-sm italic font-medium" data-id="element-31">
                {bonus.benefit}
              </p>
            </motion.div>)}
        </div>

        <motion.div initial={{
        opacity: 0,
        scale: 0.95
      }} whileInView={{
        opacity: 1,
        scale: 1
      }} viewport={{
        once: true
      }} className="bg-gradient-to-r from-gold-dark/20 via-gold/10 to-gold-dark/20 border border-gold/30 rounded-2xl p-8 text-center max-w-2xl mx-auto" data-id="element-32">
          <p className="text-gray-300 mb-2" data-id="element-33">Valor total de los 4 bonos</p>
          <p className="text-2xl text-gray-500 line-through mb-4" data-id="element-34">USD 54,00</p>
          <p className="text-lg text-white mb-2" data-id="element-35">Tu precio hoy</p>
          <p className="text-5xl font-bold text-gold-gradient mb-4" data-id="element-36">
            🎁 GRATIS
          </p>
          <p className="text-sm text-gold-light" data-id="element-37">
            Solo incluidos en esta oferta.
          </p>
        </motion.div>

        <CountdownTimer data-id="element-38" />
      </div>
    </section>;
}